import { supportedLocales } from "@/i18n";
import { HttpStatusCode } from "axios";
import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().nonempty(),
  locale: z.enum(supportedLocales),
});

export type LoginDTO = z.infer<typeof loginSchema>;

export type LoginResponseDTO =
  | {
      message: string;
    }
  | {
      token: string;
    };

export type LoginResponse =
  | {
      status: Exclude<HttpStatusCode, HttpStatusCode.Ok>;
      message: string;
    }
  | {
      status: HttpStatusCode.Ok;
      token: string;
    };

export const twoFactorAuthSchema = z.object({
  email: z.string().email(),
  twoFactorToken: z.string().length(6),
  locale: z.enum(supportedLocales),
});

export type TwoFactorAuthDTO = z.infer<typeof twoFactorAuthSchema>;

export type UpdateUserDTO = Partial<{
  name: string;
  lastName: string;
  email: string;
  phone: string;
}>;
